var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"header-navigation"},_vm._l((_vm.getItems()),function(item,index){return _c('div',{key:((item.id) + "-" + index),staticClass:"nav-item"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(item.component,_vm._b({tag:"component"},'component',item.props,false))],1)],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c628305","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/AppHeader/AppHeaderNavigation.vue
// module id = null
// module chunks = 